<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="text-container">{{dialogTitle}}</span>
  <button mat-icon-button (click)="closeDialogDetalleManoDeObraCompuesta()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey">
  <mat-card-content>
    <div class="mat-elevation-z4 div-ajusted">
      Nro de Registros : {{ nroRegistros }}
    </div>
    <div class="mat-elevation-z4 div-ajusted div-full-width">
      <form [formGroup]="manoDeObraCompuestaForm">
        <div class="row-flex" fxLayout="row" fxLayoutGap="6px" fxLayout.sm="column" fxLayout.xs="column">
          <div class="col" fxLayout="column">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Referencia</mat-label>
                  <input matInput formControlName="reference" required>
              </mat-form-field>
          </div>
          <div class="col" fxLayout="column">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
              <mat-label>Fecha</mat-label>
              <input matInput formControlName="updateDate" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex">
          <div class="col">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Denominación</mat-label>
                  <input matInput formControlName="description" required>
              </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxLayout="row" fxLayoutGap="6px" fxLayout.sm="column" fxLayout.xs="column">
          <div class="col" fxLayout="column">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Jornal</mat-label>
                  <input matInput formControlName="jornal"class="input-align-right" required>
              </mat-form-field>
          </div>
          <div class="col" fxLayout="column">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                <mat-label>Bono</mat-label>
                <input matInput formControlName="bono" class="input-align-right" required>
            </mat-form-field>
          </div>
        </div>
        <div class="row-flex">
          <div class="col">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Agrupación</mat-label>
                  <input matInput formControlName="laborGrouping" required>
              </mat-form-field>
          </div>
        </div>
        <div class="row-flex">
          <div class="col">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Instrucción</mat-label>
                  <textarea matInput formControlName="instruction" required></textarea>
              </mat-form-field>
          </div>
        </div>
        <div class="row-flex">
          <div class="col">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Experiencia</mat-label>
                  <textarea matInput formControlName="experience" required></textarea>
              </mat-form-field>
          </div>
        </div>
        <div class="row-flex">
          <div class="col">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Conocimientos</mat-label>
                  <textarea matInput formControlName="requisiteExpertise" required></textarea>
              </mat-form-field>
          </div>
        </div>
        <div class="row-flex">
          <div class="col">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Tareas</mat-label>
                  <textarea matInput formControlName="task" required></textarea>
              </mat-form-field>
          </div>
        </div>
        <div class="row-flex">
          <div class="col">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Agrupación</mat-label>
                  <input matInput formControlName="laborGrouping" required>
              </mat-form-field>
          </div>
        </div>
        <div class="row-flex">
          <div class="col">
              <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                  <mat-label>Comentario</mat-label>
                  <input matInput formControlName="commentary" required>
              </mat-form-field>
          </div>
        </div>
        <div class="row-flex" fxLayout="row" fxLayoutGap="6px" fxLayout.sm="column" fxLayout.xs="column">
          <div class="col" fxLayout="column">
            <section>
              <mat-checkbox class="checkbox-margin-left" [disabled]="true">Relacionar Dólar</mat-checkbox>
            </section>
          </div>
          <div class="col" fxLayout="column">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                <mat-label>Jornal en Dólares</mat-label>
                <input matInput formControlName="jornal$" class="input-align-right" required>
            </mat-form-field>
          </div>
          <div class="col" fxLayout="column">
            <section>
              <mat-checkbox class="checkbox-margin-left" formControlName="contributesVan">Aporta V.A.N.</mat-checkbox>
            </section>
          </div>
          <div class="col" fxLayout="column">
            <mat-form-field appearance="outline" class="full-width" floatLabel="always">
                <mat-label>V.A.N.</mat-label>
                <input matInput formControlName="van" class="input-align-right" required>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>
